<template>
  <div v-if="data.data.pbx_call">
    <p class="lead text-center font-medium-3">SIP Calls</p>
    <tr class="data-row">
      <pbx-call-data
        v-for="data in data.data.pbx_call"
        :key="`pbx-call-data-${data.id}`"
        :data="data"
      />
    </tr>
    <tr class="action-row">
      <!-- <th>{{ $t("grid.slots.info.actions") }}</th> -->
      <td class="d-flex justify-content-center">
        <a
          href="#"
          class="btn btn-sm btn-success mx-5"
          @click.prevent="callFromAlarmSlot(data.data.pbx_call[0])"
        >
          {{ $t("grid.slots.info.sip_call.make_call") }}
        </a>
      </td>
    </tr>
  </div>
</template>
<script>
import PbxCallData from "./PbxCallData.vue";
import store from "@/store";
import moment from "moment-timezone";
import { EventBus } from "@/libs/event-bus";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    PbxCallData,
  },
  props: {
    data: Object,
  },
  methods: {
    makeCall(data) {
      EventBus.emit(`call_device`, { id: data.device.find(
        (device) => device.pivot.rol === "caller"
      ).extension});
    },
    callFromAlarmSlot(data) {
      const provider = 'omnicloud'
      const deviceToCall = data.device.find(
        (device) => device.pivot.rol === "receiver"
      ).extension
      EventBus.emit(`call_device_from_alarm_omnicloud`, {...data, provider, deviceToCall});
    },
    showMessage(title, msg, variant = "success") {
      this.$toast({
        component: ToastificationContent,
        position: "top-right",
        props: {
          title,
          variant,
          icon: "BellIcon",
          text: msg,
          timeout: 5000,
        },
      });
    },
  },
  mounted() {
    // Emitir evento si hay datos PBX
    if (this.data && this.data.data && this.data.data.pbx_call && this.data.data.pbx_call.length > 0) {
      this.$emit('has-pbx-data', true);
    }
  },
};
</script>
<style scoped>
.data-row,
.action-row {
  display: block;
}
</style>
